import * as React from "react";
import cx from "classnames";
import { HTMLProps } from "react";
import { withStyles } from "src/decorators";
import styled from "styled-components";
import { MediaQueries } from "../../constants";

export const Card = withStyles(
  ({ children, className, ...props }: HTMLProps<HTMLDivElement>) => {
    const classNames = cx("tjr-card", className);
    return (
      <div className={classNames} {...props}>
        {children}
      </div>
    );
  }
);

export const CardBody = withStyles(
  ({ children, className, ...props }: HTMLProps<HTMLDivElement>) => {
    const classNames = cx("tjr-card__body", className);
    return (
      <div className={classNames} {...props}>
        {children}
      </div>
    );
  }
);

export const CardFooter = withStyles(
  ({ children, className, ...props }: HTMLProps<HTMLDivElement>) => {
    const classNames = cx(
      "tjr-card__footer",
      "asp-utility--border-top-light",
      className
    );
    return (
      <div className={classNames} {...(props as any)}>
        {children}
      </div>
    );
  }
);

const CardHeaderEl: any = styled.div`
  justify-content: space-between;
`;

export const CardHeader = withStyles(
  ({ children, className, ...props }: HTMLProps<HTMLDivElement>) => {
    const classNames = cx("tjr-card__header", className);
    return (
      <CardHeaderEl className={classNames} {...props}>
        {children}
      </CardHeaderEl>
    );
  }
);

const CardTitleEl: any = styled.div`
  width: auto;
`;

export const CardTitle = ({
  children,
  className,
  ...other
}: HTMLProps<HTMLDivElement>) => {
  const classNames = cx(["tjr-card__title", className]);
  return (
    <CardTitleEl className={classNames} {...other}>
      {children}
    </CardTitleEl>
  );
};

export const CardActions = ({
  children,
  className,
  ...props
}: HTMLProps<HTMLDivElement>) => {
  const classNames = cx("tjr-card__actions", className);
  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};

const CardActionEl: any = styled.div`
  padding: 0;
  ${MediaQueries.screen.medium.minWidth} {
    padding: 0 ${(props) => props.theme.layout.margin.l}px;
  }
`;

type CardActionItemProps = {
  persistent?: boolean;
} & HTMLProps<HTMLDivElement>;

export const CardActionItem = ({
  children,
  className,
  persistent,
  ...props
}: CardActionItemProps) => {
  const classNames = cx("tjr-card__action", className, {
    "tjr-card__action--persistent": persistent,
  });
  return (
    <CardActionEl className={classNames} {...props}>
      {children}
    </CardActionEl>
  );
};
